import { FormHelperText, styled } from '@mui/material';

export const CustomFormHelperText = styled(FormHelperText)({
	fontSize: '12px',
	textAlign: 'right',
	marginRight: '12px',
	marginTop: '0',
});
